import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss']
})
export class ReviewComponent implements OnInit {
  @Input() review: any;
  isShowImage: boolean = false;

  ngOnInit(): void {
    if (this.review && this.review.reviewText) {
      const review = this.review.reviewText.split('!@#');
      this.review.quickPhrase = review && review[1] ? review[1] : "";
      this.review.description = review && review[2] ? review[2] : "";
    }
  }
}
